<template>
  <v-container v-if="teams[$route.params.team].account">
    <v2-row>
      <v2-col col12 noSpace>
        <v2-header-bar :titles="[{ label: $t('titles.activityFeeds') }]"></v2-header-bar>
      </v2-col>
    </v2-row>
    <v-row>
      <v-col class="col-12">
        <v-tabs
          :tabs="tabs"
          @setActiveTab="
            (slug) => {
              setActiveTab(slug);
            }
          "
          :active="getActiveTab()"
        >
          <div :slot="tabs[0]">
            <v-activity-feed-items-grouped
              :activityFeedItemsGrouped="activityFeedItemsGrouped"
              :timezone="teams[$route.params.team].account.timezone"
              :loadMoreIsLoading="loadMoreIsLoading"
              @loadMore="
                (nextChunk) => {
                  loadMore('Grouped', nextChunk);
                }
              "
            />
          </div>
          <div :slot="tabs[1]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedFileUploads.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="fileUploads"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedFileUploads.data.next_chunk_from ? true : false"
              @loadMore="loadMore('FileUpload', activityFeedFileUploads.data.next_chunk_from)"
            />
          </div>
          <div :slot="tabs[2]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedFileDownloads.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="fileDownloads"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedFileDownloads.data.next_chunk_from ? true : false"
              @loadMore="loadMore('FileUploads', activityFeedFileDownloads.data.next_chunk_from)"
            />
          </div>
          <div :slot="tabs[3]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedPageViews.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="pageViews"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedPageViews.data.next_chunk_from ? true : false"
              @loadMore="loadMore('PageView', activityFeedPageViews.data.next_chunk_from)"
            />
          </div>
          <div :slot="tabs[4]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedProjectMessages.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="projectMessages"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedProjectMessages.data.next_chunk_from ? true : false"
              @loadMore="loadMore('ProjectMessage', activityFeedProjectMessages.data.next_chunk_from)"
            />
          </div>
          <div :slot="tabs[5]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedProjectFileSignings.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="projectFileSignings"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedProjectFileSignings.data.next_chunk_from ? true : false"
              @loadMore="loadMore('ProjectMessage', activityFeedProjectFileSignings.data.next_chunk_from)"
            />
          </div>
          <div :slot="tabs[6]">
            <h2>{{ $t("labels.projectsSubscription") }}</h2>
            <div class="mb-5">{{ $t("labels.projectsSubscriptionDesc") }}</div>
            <ul class="list">
              <router-link
                :to="{
                  name: 'Project',
                  params: { uid: project.uid, tab: 'overview' },
                }"
                v-for="project in projectsSubscriptions"
                :key="project.uid"
              >
                <v-list-item complex hover>
                  <v-list-cell icon="Icon=folder.svg" iconFill iconColor="#5057af" />
                  <v-list-cell
                    :title="project.title"
                    size="2"
                    :subtitle="
                      $h.formatName(project.owner, true) +
                      ' • ' +
                      $h.formatDate(project.updated_at, teams[$route.params.team].account.timezone, true)
                    "
                  />
                  <v-list-cell
                    iconDropdown
                    gray
                    icon="Icon=more-horizontal.svg"
                    iconColor="#5057af"
                    :dropdownData="projectsSubscriptionsMoreDropdown"
                    :dropdownUid="$h.createUniqueUid()"
                    :dropdownValue="project"
                  />
                </v-list-item>
              </router-link>
              <v-list-item v-if="projectsSubscriptions && !projectsSubscriptions.length">
                <v-list-cell :value="$t('placeholders.noProjectsSubscriptions')"></v-list-cell>
              </v-list-item>
            </ul>
            <v-list-pagination
              v-if="projectsSubscriptionsPagination"
              class="mb-16"
              :currentPage="projectsSubscriptionsPagination.current_page"
              :showPerPage="projectsSubscriptionsPagination.per_page"
              :totalPages="projectsSubscriptionsPagination.last_page"
              :apiCall="
                (page, perPage) => {
                  getProjectsSubscriptions({
                    params: {
                      page,
                      per_page: perPage,
                      order_col: projectsSubscriptionsOrder.col,
                      order_dir: projectsSubscriptionsOrder.dir,
                    },
                  });
                }
              "
            >
            </v-list-pagination>
            <h2>{{ $t("labels.clientsSubscription") }}</h2>
            <div class="mb-5">{{ $t("labels.clientsSubscriptionDesc") }}</div>
            <ul class="list">
              <router-link
                :to="{ name: 'Client', params: { uid: client.uid } }"
                v-for="client in clientsSubscriptions"
                :key="client.uid"
              >
                <v-list-item complex hover>
                  <v-list-cell icon="Icon=user.svg" iconColor="#5057af" />
                  <v-list-cell
                    :title="$h.formatName(client, true)"
                    size="2"
                    :subtitle="client.company + ' • ' + $tc('client.projectsCount', client.projects_count)"
                  />
                  <v-list-cell
                    iconDropdown
                    gray
                    icon="Icon=more-horizontal.svg"
                    iconColor="#5057af"
                    :dropdownData="clientsSubscriptionsMoreDropdown"
                    :dropdownUid="$h.createUniqueUid()"
                    :dropdownValue="client"
                  />
                </v-list-item>
              </router-link>
              <v-list-item v-if="clientsSubscriptions && !clientsSubscriptions.length">
                <v-list-cell :value="$t('placeholders.noClientsSubscriptions')"></v-list-cell>
              </v-list-item>
            </ul>
            <v-list-pagination
              v-if="clientsSubscriptionsPagination"
              class="mb-16"
              :currentPage="clientsSubscriptionsPagination.current_page"
              :showPerPage="clientsSubscriptionsPagination.per_page"
              :totalPages="clientsSubscriptionsPagination.last_page"
              :apiCall="
                (page, perPage) => {
                  getClientsSubscriptions({
                    params: {
                      page,
                      per_page: perPage,
                      order_col: clientsSubscriptionsOrder.col,
                      order_dir: clientsSubscriptionsOrder.dir,
                    },
                  });
                }
              "
            >
            </v-list-pagination>
            <h2>{{ $t("labels.usersSubscription") }}</h2>
            <div class="mb-5">{{ $t("labels.usersSubscriptionDesc") }}</div>
            <ul class="list">
              <router-link
                :to="{ name: 'Settings', params: { tab: 'team' } }"
                v-for="user in usersSubscriptions"
                :key="user.uid"
              >
                <v-list-item complex hover>
                  <v-list-cell icon="Icon=user.svg" iconColor="#5057af" />
                  <v-list-cell :title="$h.formatName(user, true)" size="2" :subtitle="user.email" />
                  <v-list-cell
                    iconDropdown
                    gray
                    icon="Icon=more-horizontal.svg"
                    iconColor="#5057af"
                    :dropdownData="usersSubscriptionsMoreDropdown"
                    :dropdownUid="$h.createUniqueUid()"
                    :dropdownValue="user"
                  />
                </v-list-item>
              </router-link>
              <v-list-item v-if="usersSubscriptions && !usersSubscriptions.length">
                <v-list-cell :value="$t('placeholders.noUsersSubscriptions')"></v-list-cell>
              </v-list-item>
            </ul>
            <v-list-pagination
              v-if="usersSubscriptionsPagination"
              class="mb-16"
              :currentPage="usersSubscriptionsPagination.current_page"
              :showPerPage="usersSubscriptionsPagination.per_page"
              :totalPages="usersSubscriptionsPagination.last_page"
              :apiCall="
                (page, perPage) => {
                  getUsersSubscriptions({
                    params: {
                      page,
                      per_page: perPage,
                      order_col: usersSubscriptionsOrder.col,
                      order_dir: usersSubscriptionsOrder.dir,
                    },
                  });
                }
              "
            >
            </v-list-pagination>
          </div>
          <div :slot="tabs[7]">
            <v-activity-feed-group
              :activityFeedItems="activityFeedFormResponses.items"
              :timezone="teams[$route.params.team].account.timezone"
              type="formResponses"
              :loadMoreIsLoading="loadMoreIsLoading"
              :loadMore="activityFeedFormResponses.data.next_chunk_from ? true : false"
              @loadMore="loadMore('ProjectMessage', activityFeedFormResponses.data.next_chunk_from)"
            />
          </div>
        </v-tabs>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ActivityFeeds",
  data() {
    return {
      loadMoreIsLoading: false,
      tabs: [
        this.$t("menus.all"),
        this.$t("menus.fileUploads"),
        this.$t("menus.fileDownloads"),
        this.$t("menus.pageViews"),
        this.$t("menus.projectMessages"),
        this.$t("menus.projectFileSignings"),
        this.$t("menus.subscriptions"),
        this.$t("menus.formResponses"),
      ],
      projectsSubscriptionsOrder: {
        col: "",
        dir: "",
      },
      clientsSubscriptionsOrder: {
        col: "",
        dir: "",
      },
      usersSubscriptionsOrder: {
        col: "",
        dir: "",
      },
      projectsSubscriptionsMoreDropdown: [
        {
          options: [
            {
              label: this.$t("actions.removeSubscription"),
              method: (project) => {
                this.removeProjectSubscription(project.uid);
              },
            },
          ],
        },
      ],
      clientsSubscriptionsMoreDropdown: [
        {
          options: [
            {
              label: this.$t("actions.removeSubscription"),
              method: (client) => {
                this.removeClientSubscription(client.uid);
              },
            },
          ],
        },
      ],
      usersSubscriptionsMoreDropdown: [
        {
          options: [
            {
              label: this.$t("actions.removeSubscription"),
              method: (user) => {
                this.removeUserSubscription(user.uid);
              },
            },
          ],
        },
      ],
    };
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
    this.setProjectsActivityFeedsRead();
    this.loadPageData();
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    ...mapActions([
      "setMenus",
      "getProjectsActivityFeeds",
      "setProjectsActivityFeedsRead",
      "getProjectsSubscriptions",
      "getClientsSubscriptions",
      "getUsersSubscriptions",
      "deleteProjectSubscription",
      "deleteClientSubscription",
      "deleteUserSubscription",
    ]),
    loadPageData() {
      this.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
      const vm = this;
      if (vm.$route.params.tab === "all") {
        this.getProjectsActivityFeeds({ type: "Grouped" })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "filedownloads") {
        this.getProjectsActivityFeeds({
          params: { event_type: "FileDownload" },
        })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "fileuploads") {
        this.getProjectsActivityFeeds({ params: { event_type: "FileUpload" } })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "projectfilesignings") {
        this.getProjectsActivityFeeds({ params: { event_type: "ProjectFileSigned" } })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "pageviews") {
        this.getProjectsActivityFeeds({ params: { event_type: "PageView" } })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "formresponses") {
        this.getProjectsActivityFeeds({ params: { event_type: "FormResponse" } })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "projectmessages") {
        this.getProjectsActivityFeeds({
          params: { event_type: "ProjectMessage" },
        })
          .then(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else if (vm.$route.params.tab === "abonnements") {
        const p1 = this.getProjectsSubscriptions();
        const p2 = this.getClientsSubscriptions();
        const p3 = this.getUsersSubscriptions();
        Promise.all([p1, p2, p3])
          .then(() => {
            this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          })
          .catch(() => {
            this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
          });
      } else {
        this.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");
      }
    },
    loadMore(type, from) {
      this.loadMoreIsLoading = true;
      type === "Grouped" &&
        this.getProjectsActivityFeeds({
          type,
          params: { from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "FileDownload" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "FileUpload" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "PageView" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "ProjectFileSigned" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "FormResponse" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
      type === "ProjectMessage" &&
        this.getProjectsActivityFeeds({
          params: { event_type: type, from },
          customLoading: true,
        })
          .then(() => {
            this.loadMoreIsLoading = false;
          })
          .catch(() => {
            this.loadMoreIsLoading = false;
          });
    },
    setActiveTab(slug) {
      switch (slug) {
        case this.tabs[0].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "all" });
        case this.tabs[1].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "fileuploads" });
        case this.tabs[2].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "filedownloads" });
        case this.tabs[3].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "pageviews" });
        case this.tabs[4].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "projectmessages" });
        case this.tabs[5].replace(/\s+/g, "-").toLowerCase():
          this.$store.commit("PROJECTS_RESET_ACTIVITY_FEEDS");
          return this.$goTo("ActivityFeeds", { tab: "projectfilesignings" });
        case this.tabs[6].replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("ActivityFeeds", { tab: "abonnements" });
        case this.tabs[7].replace(/\s+/g, "-").toLowerCase():
          return this.$goTo("ActivityFeeds", { tab: "formresponses" });
      }
    },
    getActiveTab() {
      switch (this.$route.params.tab) {
        case "all":
          return this.tabs[0].replace(/\s+/g, "-").toLowerCase();
        case "fileuploads":
          return this.tabs[1].replace(/\s+/g, "-").toLowerCase();
        case "filedownloads":
          return this.tabs[2].replace(/\s+/g, "-").toLowerCase();
        case "pageviews":
          return this.tabs[3].replace(/\s+/g, "-").toLowerCase();
        case "projectmessages":
          return this.tabs[4].replace(/\s+/g, "-").toLowerCase();
        case "projectfilesignings":
          return this.tabs[5].replace(/\s+/g, "-").toLowerCase();
        case "abonnements":
          return this.tabs[6].replace(/\s+/g, "-").toLowerCase();
        case "formresponses":
          return this.tabs[7].replace(/\s+/g, "-").toLowerCase();
      }
    },
    removeProjectSubscription(uid) {
      this.deleteProjectSubscription({ customLoading: true, project: uid })
        .then(() => {
          this.getProjectsSubscriptions({
            params: {
              page: this.projectsSubscriptionsPagination.current_page,
              per_page: this.projectsSubscriptionsPagination.per_page,
              order_col: this.projectsSubscriptionsOrder.col,
              order_dir: this.projectsSubscriptionsOrder.dir,
            },
          });
          this.$snotify.success(this.$t("toasts.deleteSubscription.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteSubscription.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    removeClientSubscription(uid) {
      this.deleteClientSubscription({ customLoading: true, client: uid })
        .then(() => {
          this.getClientsSubscriptions({
            params: {
              page: this.clientsSubscriptionsPagination.current_page,
              per_page: this.clientsSubscriptionsPagination.per_page,
              order_col: this.clientsSubscriptionsOrder.col,
              order_dir: this.clientsSubscriptionsOrder.dir,
            },
          });
          this.$snotify.success(this.$t("toasts.deleteSubscription.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteSubscription.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
    removeUserSubscription(uid) {
      this.deleteUserSubscription({ customLoading: true, user: uid })
        .then(() => {
          this.getUsersSubscriptions({
            params: {
              page: this.usersSubscriptionsPagination.current_page,
              per_page: this.usersSubscriptionsPagination.per_page,
              order_col: this.usersSubscriptionsOrder.col,
              order_dir: this.usersSubscriptionsOrder.dir,
            },
          });
          this.$snotify.success(this.$t("toasts.deleteSubscription.success"), this.$t("toasts.success"), {
            icon: this.$successIcon,
          });
        })
        .catch((err) => {
          if (err.response && !err.response.data.error.custom) {
            this.$snotify.error(this.$t("toasts.deleteSubscription.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      activityFeedItemsGrouped: "projects_get_activity_feed_items_grouped",
      activityFeedFileDownloads: "projects_get_activity_feed_filedownloads",
      activityFeedFileUploads: "projects_get_activity_feed_fileuploads",
      activityFeedPageViews: "projects_get_activity_feed_pageviews",
      activityFeedProjectMessages: "projects_get_activity_feed_projectmessages",
      activityFeedProjectFileSignings: "projects_get_activity_feed_projectfilesignings",
      activityFeedFormResponses: "projects_get_activity_feed_form_responses",
      projectsSubscriptions: "subscriptions_get_projects_subscriptions",
      projectsSubscriptionsPagination: "subscriptions_get_projects_subscriptions_pagination",
      clientsSubscriptions: "subscriptions_get_clients_subscriptions",
      clientsSubscriptionsPagination: "subscriptions_get_clients_subscriptions_pagination",
      usersSubscriptions: "subscriptions_get_users_subscriptions",
      usersSubscriptionsPagination: "subscriptions_get_users_subscriptions_pagination",
    }),
  },
};
</script>
